import React, { useEffect, useState } from "react";
import MapPicker from "react-google-map-picker";
import { GOOGLE_MAPS_API_KEY } from "../utils/GoogleMapKey";
import { Box, Center, Spinner, Text } from "@chakra-ui/react";

const PortalMapPicker = ({
  handleChangeLocation,
  zoom,
  handleChangeZoom,
  defaultLocation,
}) => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    let timer = setTimeout(() => setShow(true), 10000);

    return () => {
      clearTimeout(timer);
    };
  }, []);

  if (!show)
    return (
      <Center w='100%' h='200px' flexDir='column' gap={3}>
        <Spinner color='#D32127' />
        <Text>Loading Map...</Text>
      </Center>
    );

  return (
    <>
      <MapPicker
        mapTypeId='roadmap'
        onChangeLocation={handleChangeLocation}
        apiKey={GOOGLE_MAPS_API_KEY}
        defaultLocation={defaultLocation}
        zoom={zoom}
        onChangeZoom={handleChangeZoom}
        style={{
          width: "100%",
          height: "200px",
        }}
      />
    </>
  );
};

export default PortalMapPicker;
